import {
  PublicJobAlertSubscriptionRequestSchema,
  PublicJobAlertSubscriptionResponseSchema,
  type PublicJobAlertSubscriptionRequestDto,
  type PublicJobAlertSubscriptionResponseDto,
} from "@artha/api-contracts";
import { API_ROUTES } from "@artha/types";
import { apiFetch, type ApiResult } from "@/lib/apiClient";

type ApiPayload<T> = T | { data: T };

type ApiErrorResponse = {
  success?: false;
  error?: {
    message?: string;
  };
};

const unwrapApiData = <T>(res: ApiResult<ApiPayload<T>>): T => {
  const payload = res.data as ApiPayload<T>;

  if (payload && typeof payload === "object" && "data" in (payload as Record<string, unknown>)) {
    return (payload as { data: T }).data;
  }

  return payload as T;
};

export const normalizePublicJobAlertUsername = (username: string) =>
  username.trim().replace(/^@+/, "").toLowerCase();

export const savePublicJobAlertSubscription = async (
  username: string,
  draft: PublicJobAlertSubscriptionRequestDto,
): Promise<PublicJobAlertSubscriptionResponseDto> => {
  const normalizedUsername = normalizePublicJobAlertUsername(username);
  const payload = PublicJobAlertSubscriptionRequestSchema.parse(draft);

  const response = await apiFetch<ApiPayload<PublicJobAlertSubscriptionResponseDto>>(
    API_ROUTES.JOBS.PUBLIC_ALERT_SUBSCRIPTIONS(normalizedUsername),
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    const error = response.data as ApiErrorResponse | undefined;
    throw new Error(error?.error?.message || "Failed to save job alert subscription");
  }

  return PublicJobAlertSubscriptionResponseSchema.parse(unwrapApiData(response));
};
